export default {

    //Text that is over the main image
    imagePlaceholderMain: "Outperform Your Competition",
    imagePlaceholderSubLine: "Through Innovative and Sustainable Solutions",
    imageButtonText: "Action Button",


    //Text just below the main image
    mainTextShort: "The Aethilus Advantage",
    mainTextDescription: "Outperforming competition and maintaining leadership is a constant battle. The battle ground is constantly changing and it needs innovative solutions to win. At Aethilus we co-create winning solutions to enable YOUR success. Our solutions are based on on the ground insights gained over 30+ years.",


    //Text explaining our services
    enterpriseHeading: "Enterprise",
    enterpriseDescription: "We enable increased revenue by addressing critical factors which impact sales such as Win ratio, value proposition and a strong sales process from opportunity identification to closure.  We enable margin enhancement by avoiding, optimizing and transforming the key cost elements. Both revenue and margin leverage our work force planning and development solutions.",

    executiveHeading: "Executive",
    executiveDescription: "Management executives are striving hard with unending days, ever increasing targets and virtually no margin for error. Our services enable management executives to excel in their professional endeavors through a personal development plan.",
    
    studentHeading: "Students",
    studentDescription: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took it to make a type specimen book. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took it to make a type specimen book.",

    //Optimus Heading
    optimusHeading: "Optimus Spark",
    optimusDescription: "A next generation talent assessment and development platform. The platform helps with the complete life cycle of talent management in the enterprise."

}


// WEBPACK FOOTER //
// ./src/text.js